import { cn } from '@/lib/cn';
import * as React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  touched?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, touched, id, ...props }, ref) => {
    return (
      <div className="group relative w-full">
        <div className="relative">
          <textarea
            className={cn(
              'border-input ring-offset-background focus-visible:border-secondary peer flex min-h-30 w-full rounded-[0.625rem] border bg-transparent px-4 py-4 text-lg placeholder:text-transparent focus-visible:border-[0.09375rem] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
              touched && error
                ? 'border-destructive focus-visible:border-destructive'
                : '',
              className,
            )}
            ref={ref}
            placeholder=" "
            id={id}
            {...props}
          />
          {label && (
            <div
              className={cn(
                'pointer-events-none absolute left-4 flex items-start pt-4 transition-all duration-200 ease-out',
                'peer-focus:bg-background peer-[:not(:placeholder-shown)]:bg-background peer-focus:-top-3 peer-focus:h-auto peer-focus:px-1 peer-focus:pt-0 peer-focus:text-xs peer-[:not(:placeholder-shown)]:-top-3 peer-[:not(:placeholder-shown)]:h-auto peer-[:not(:placeholder-shown)]:px-1 peer-[:not(:placeholder-shown)]:pt-0 peer-[:not(:placeholder-shown)]:text-xs',
                (touched && error) || props.value || props.defaultValue
                  ? 'bg-background -top-3 h-auto px-1 pt-0 text-xs'
                  : 'top-0',
              )}
            >
              <label
                htmlFor={id}
                className={cn(
                  'text-muted-foreground peer-focus:text-secondary font-normal',
                  touched && error ? 'text-destructive' : '',
                )}
              >
                {label}
              </label>
            </div>
          )}

          {touched && error && (
            <div className="text-destructive pointer-events-none absolute top-4 right-4 text-sm font-light">
              {error}
            </div>
          )}
        </div>
      </div>
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
